import { useEffect } from 'react';
import { useDispatch } from '@lingoda/hooks';
import { QueryFlag, getQueryFlag } from '@lingoda/router';
import { DialogComponent, showDialog } from '@lingoda/dialogs';

interface Options {
    dialogTimeout?: number;
}

export const useYearlyRecapDialog = ({ dialogTimeout = 2000 }: Options = {}) => {
    const dispatch = useDispatch();

    useEffect(() => {
        let timeoutId: number;
        const shouldOpenRecap = getQueryFlag(QueryFlag.showYearlyRecap);
        if (shouldOpenRecap) {
            // Setup some timeout to let the page render first, and then open a dialog
            // Otherwise the dialog appears while page is still building in the background.
            timeoutId = window.setTimeout(() => {
                dispatch(showDialog(DialogComponent.YearlyRecapDialog));
            }, dialogTimeout);
        }

        return () => clearTimeout(timeoutId);
    }, [dispatch, dialogTimeout]);
};
